/*
    Přidání kategorie
*/
import React,{ Component,Fragment } from 'react';
import {Mutation,Query} from 'react-apollo';
import Loading from '../../../GlobalComponents/Loading';
import Error from '../../../GlobalComponents/Error';
import Modal from 'react-modal';
import { Editor } from '@tinymce/tinymce-react';
import {ADD_EDIT_SERVICE,GET_SERVICES,GET_SERVICE} from '../Queries/index.js';
import { withApollo } from 'react-apollo';
import Notification from '../../../Library/notification';
import Helper from '../../../Library/helper';
import ServiceLib from '../Library/service';


const INITIAL_STATE = {
    err:"",
    formData:{
        serviceID:0,
        langs:[],
        selectedLang:'cz',
        selectedCurrency:'Kč',
    },
    allVats:[],
    allLanguageMutations:[]
}

class AddEditService extends Component{

    constructor(props){
        super(props);
        this.state = INITIAL_STATE;
        
        this.serviceLib = new ServiceLib(this); 
    }

    componentDidMount(){
        this.serviceLib.getData();
    }    

    render(){

        var {err}               = this.state;
        var {selectedServiceID,listVariables} = this.props;

        return(

            <Mutation 
                mutation={ADD_EDIT_SERVICE}
                errorPolicy = "all"
                update = {async (cache, response) => {
                    this.serviceLib.updateList(cache,response,selectedServiceID,listVariables);

                    let notify = new Notification();

                    if(selectedServiceID && selectedServiceID != 0) notify.setNotification(cache,'Úspěšně uloženo',true,false);
                    else notify.setNotification(cache,'Úspěšně přidáno',true,false);

                }}

                onCompleted = {() => {
                    this.props.openCloseModal(false);
                }}
                
            >
            {
                (addEditService,{loading, error}) => {

                    const {active,selectedLang,selectedCurrency} = this.state.formData;
                    const {allLanguageMutations,allVats} = this.state;
                    
                    if(error){
                        const helper = new Helper(); 
                        err = helper.getApolloErrorText(error);
                    }

                    return(
                        <Modal
                            className="Modal__Bootstrap modal-dialog modal-lg"
                            closeTimeoutMS={150}
                            isOpen={true}
                            onRequestClose={() => this.props.openCloseModal(false)}
                        >
                            <div className="modal-content">
                                <div className="modal-header d-flex align-items-center">
                                    <h4 className="modal-title">{(selectedServiceID && selectedServiceID != 0 ? "Úprava služby" : "Přidání služby")}</h4>
                                    <div className="ml-auto">
                                        <select className="form-control" name="selectedLang" onChange={(e) => this.serviceLib.formLangObjectHandle(e)}>
                                            {allLanguageMutations && allLanguageMutations.map((item,index) => (
                                                <option key={index} value={item.languageID}> {item.suffix} </option>
                                            ))}
                                        </select>
                                    </div>
                                    <button type="button" className="close ml-3" onClick={() => this.props.openCloseModal(false)}>                                    
                                        <span aria-hidden="true">x</span>
                                        <span className="sr-only">Close</span>
                                    </button>
                                </div>
                                <div className="modal-body">

                                    {err ?
                                        <Error text={err} />
                                    :
                                        <Fragment>
                                            {!loading ?
                                            <div className="row">                
                                                <div className="col-12 col-sm-4">
                                                    <label className="input-label">Název služby ({selectedLang})</label>
                                                    <div className="form-group">
                                                        <input className="form-control" type="text" name="name" value={this.serviceLib.getLangValue("name")} onChange={(e) => this.serviceLib.formLangHandle(e)} />
                                                    </div>
                                                </div>  
                                                <div className="col-12 col-sm-2">
                                                    <label className="input-label">Cena služby ({selectedLang})</label>
                                                    <div className="input-group">
                                                        <input className="form-control" type="number" step=".1" name="price" value={this.serviceLib.getLangValue("price")} onChange={(e) => this.serviceLib.formLangHandle(e)} />
                                                        
                                                        <div className="input-group-append">
                                                            <span className="input-group-text">{selectedCurrency}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-2">
                                                    <label className="input-label">DPH ({selectedLang})</label>
                                                    <div className="input-group">
                                                        <select value={this.serviceLib.getLangValue("vat")} className="form-control" name="vat" onChange={(e) => this.serviceLib.formLangHandle(e)}>
                                                            {allVats && allVats.map((item,index) => (
                                                                <option key={index} value={item.value}>{item.value} %</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <label className="input-label">Text emailu ({selectedLang})</label>
                                                    <div className="form-group">
                                                        <Editor
                                                            name="emailText"
                                                            apiKey = '9z3phhnyq7jkeeqztql1euovfotvpd2gdduygtdpk14wu4ij'
                                                            value={this.serviceLib.getLangValue("emailText")}
                                                            init={{
                                                                plugins: 'link code paste emoticons',
                                                                toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | formatselect | link | blockquote | emoticons | code',
                                                                paste_as_text: true,
                                                                language_url : '/langs/cs.js',
                                                                language: "cs",
                                                            }}
                                                            onEditorChange={(content) => this.serviceLib.formLangHandleEditor(content,"emailText")}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            :

                                            <Loading />  

                                            }  
                                        </Fragment>
                                    }
                                            
                                </div>
                                <div className="modal-footer"> 
                                    {!loading && <button type="button" className="btn btn-primary flex-fill" onClick={() => this.serviceLib.addService(addEditService)}>{(selectedServiceID && selectedServiceID != 0 ? "Upravit" : "Přidat")}</button>}
                                    <button type="button" className="btn btn-danger" onClick={() => this.props.openCloseModal(false)}>Zavřít</button>
                                </div>
                            </div>
                        </Modal>
                    );

                }
            }
            </Mutation>
        
        );

    }

}

export default withApollo(AddEditService);